import { Locale } from '../types';

import frenchFormats from './fr/time-formats.json';
import englishFormats from './en/time-formats.json';
import germanFormats from './de/time-formats.json';

export type TimeFormat = 'time_default' | 'at_time';

export type TimeFormats = Record<TimeFormat, string>;

export const STANDARD_TIME_FORMAT = 'HH:mm';

export const TIME_FORMATS_BY_LOCALE: Record<Locale, TimeFormats> = {
  fr: frenchFormats,
  'fr-CH': frenchFormats,
  en: englishFormats,
  de: germanFormats,
  'de-AT': germanFormats,
  'de-CH': germanFormats,
};
